type Option = { value: string; label: string };

export default function optionLabel(options: Option[], value: any): string {
    if (value === null || value === undefined || value === '' || value === false) return '';
    const casvMapped = typeof value === 'string' && value.indexOf('casv_') === 0
        ? value.replace(/^casv_/, '')
        : value;
    const found = options.find(o => o.value === value)
        || (casvMapped !== value ? options.find(o => o.value === casvMapped) : undefined);
    return found ? found.label : '';
}
